/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'shop-info': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M64 64h192v192H64V64zM320 64h192v192H320V64zM576 64h192v192H576V64zM832 64h192v192H832V64zM64 320h192v192H64V320zM320 320h192v192H320V320zM576 320h192v192H576V320zM832 320h192v192H832V320zM64 576h192v192H64V576zM320 576h192v192H320V576zM576 576h192v192H576V576zM832 576h192v192H832V576zM64 832h192v192H64V832zM320 832h192v192H320V832zM576 832h192v192H576V832zM832 832h192v192H832V832z"/>'
  }
})
